import { render } from "./ServicesVtc.vue?vue&type=template&id=3b407f19&scoped=true"
import script from "./ServicesVtc.vue?vue&type=script&lang=js"
export * from "./ServicesVtc.vue?vue&type=script&lang=js"

import "./ServicesVtc.vue?vue&type=style&index=0&id=3b407f19&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b407f19"]])

export default __exports__